import { EnumBase } from 'hay-core-react';
class ConfiguracaoRequerdatanascimentoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.configuracao.requerdatanascimento.desativado',
                'main.configuracao.requerdatanascimento.opcional',
                'main.configuracao.requerdatanascimento.obrigatorio',
            ],
            'main.configuracao.requerdatanascimento.desativado'
        );
    }
}

const instance = new ConfiguracaoRequerdatanascimentoEnum();
export default instance;
